import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import HeaderThree from "../components/header/HeaderThree";
import BannerThree from "../components/banner/BannerThree";
import AboutThree from "../components/about/AboutThree";
import ServiceThree from "../components/service/ServiceThree";
import CallToActionTwo from "../components/calltoaction/CallToActionTwo";
import BusinessGoalTwo from "../components/businessgoal/BusinessGoalTwo";
import BusinessCaseTwo from "../components/businesscase/BusinessCaseTwo";
import CounterUpTwo from "../components/counterup/CounterUpTwo";
import FaqOne from "../components/faq/FaqOne";
import TeamTwo from "../components/team/TeamTwo";
import BrandThree from "../components/brand/BrandThree";
import PricingTwo from "../components/pricing/PricingTwo";
import ContactTwo from "../components/contactform/ContactTwo";
import BlogThree from "../components/blog/BlogThree";
import CallToActionThree from "../components/calltoaction/CallToActionThree";
import FooterThree from "../components/footer/FooterThree";
import ProjectMap1 from "../components/projects_map/ProjectMap1";
import JobsMain from "../components/HIring/JobsMain";

function HomeThree() {
    const location = useLocation();

    useEffect(() => {
        // Adaugă meta date structurate pentru SEO
        const structuredData = {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "IZODROM GROUP",
            "alternateName": "IZODROMGAZ SRL",
            "url": "https://www.izodrom.md",
            "logo": "https://www.izodrom.md/sign_png.png",
            "description": "Lider în construcții civile și industriale, lucrări de terasamente, sisteme de alimentare cu apă și canalizare din Republica Moldova",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "Str. Ialoveni nr. 2",
                "addressLocality": "Ialoveni",
                "postalCode": "MD-6801",
                "addressCountry": "MD"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+37326825763",
                "contactType": "customer service"
            },
            "foundingDate": "2001",
            "numberOfEmployees": "50-249",
            "serviceArea": {
                "@type": "Country",
                "name": "Republica Moldova"
            },
            "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Servicii de Construcții și Infrastructură",
                "itemListElement": [
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Construcții civile și industriale"
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Lucrări de terasamente"
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Sisteme de alimentare cu apă și canalizare"
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Stații de epurare a apelor uzate"
                        }
                    }
                ]
            }
        };

        // Adaugă script-ul cu datele structurate în head
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(structuredData);
        document.head.appendChild(script);

        // Verifică dacă există un hash în URL pentru scroll la secțiune
        if (location.hash) {
            const sectionId = location.hash.substring(1); // Elimină #
            setTimeout(() => {
                const element = document.getElementById(sectionId);
                if (element) {
                    const headerHeight = 100;
                    const elementPosition = element.offsetTop - headerHeight;
                    
                    window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth'
                    });
                }
            }, 100); // Mic delay pentru a permite renderizarea
        } else {
            // Dacă nu există hash, scroll la început
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

        // Funcție pentru a actualiza hash-ul în funcție de scroll
        const handleScroll = () => {
            const sections = ['banner', 'about', 'services', 'projects', 'careers', 'f-contact'];
            const headerHeight = 100;
            
            for (let i = sections.length - 1; i >= 0; i--) {
                const element = document.getElementById(sections[i]);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    if (rect.top <= headerHeight + 50) {
                        const currentHash = window.location.hash.substring(1);
                        if (currentHash !== sections[i]) {
                            window.history.replaceState(null, null, `#${sections[i]}`);
                        }
                        break;
                    }
                }
            }
        };

        // Adaugă event listener pentru scroll
        window.addEventListener('scroll', handleScroll);
        
        // Cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll);
            // Elimină script-ul cu datele structurate
            const existingScript = document.querySelector('script[type="application/ld+json"]');
            if (existingScript) {
                document.head.removeChild(existingScript);
            }
        };
    }, [location]);

    return (
        <div className='home-yellow'>
            <HeaderThree />
            
            {/* Secțiunea principală cu structură semantică */}
            <main>
                <section id="banner" aria-label="Banner principal">
                    <BannerThree />
                </section>
                
                <section id="about" aria-label="Despre companie">
                    <AboutThree />
                </section>
                
                <section id="services" aria-label="Serviciile noastre">
                    <ServiceThree />
                </section>
                
                <section id="projects" aria-label="Proiectele noastre">
                    <ProjectMap1 />
                </section>
                
                <section aria-label="Obiectivele companiei">
                    <BusinessGoalTwo />
                </section>
                
                <section id="careers" aria-label="Cariere și angajări">
                    <JobsMain />
                </section>
            </main>
            
            <footer id="f-contact" aria-label="Contact și informații de contact">
                <FooterThree />
            </footer>
            
            {/* Secțiuni comentate pentru viitoare dezvoltări */}
            {/* <div id="contact">
                <ContactTwo />
            </div> */}

            {/* <CounterUpTwo />
            <BusinessCaseTwo />
            <FaqOne />
            <TeamTwo /> 
            <BrandThree />
            <PricingTwo />

            <BlogThree />
            <CallToActionThree /> */}
        </div>
    )
}

export default HomeThree